module.exports = __webpack_public_path__ + "img/ecology1.60e6ab42.jpg";